<div class="grid grid-cols-1 lg:grid-cols-4 p-3 gap-y-3 lg:gap-3 h-full" lohiPageTitle="Carrier KPIs">
  <div class="row-span-5" *ngIf="companyMetrics30Day$ | async as metrics">
    <div class="card-with-shadow bg-white p-2">
      <div class="text-lg font-bold">
        Carrier Performance <span class="text-blue-500">{{ metrics.daysOfHistory || 30 }}d</span>
      </div>
      <div class="py-2 flex border-b border-gray-400 justify-between">
        <div>Total Revenue</div>
        <div>{{ metrics.totalEarnings | currencyInPennies }}</div>
      </div>
      <div class="py-2 flex border-b border-gray-400 justify-between">
        <div>Total Lost Revenue</div>
        <lohi-number-badge [currency]="true" [count]="metrics.missedEarnings"></lohi-number-badge>
      </div>
      <div class="py-2 flex border-b border-gray-400 justify-between">
        <div>Loads Lost</div>
        <lohi-number-badge [count]="metrics.missedLoads"></lohi-number-badge>
      </div>
      <div class="py-2 flex border-b border-gray-400 justify-between">
        <div>Turn Rate</div>
        <div>{{ metrics.averageTurnRate | number: '1.1-2' }}</div>
      </div>
      <div class="py-2 flex border-b border-gray-400 justify-between">
        <div>Revenue Per Shift</div>
        <div>{{ metrics.averageRevenuePerShift | currencyInPennies }}</div>
      </div>
      <div class="py-2 flex justify-between">
        <div>Driver Earnings Per Shift</div>
        <div>{{ metrics.averageDriverEarningsPerShift | currencyInPennies }}</div>
      </div>
    </div>
    <div class="mt-3" *ngIf="metrics.earningsAggregateByCab?.sleeper?.totalEarnings">
      <lohi-pie-chart
        [sleepers]="true"
        [earnings]="metrics.earningsAggregateByCab?.sleeper?.averagePerDayEarnings"
        [lostEarnings]="metrics.earningsAggregateByCab?.sleeper?.missedAveragePerDayEarnings"
        [daysOfHistory]="metrics.daysOfHistory"
      >
      </lohi-pie-chart>
    </div>
    <div class="mt-3" *ngIf="metrics.earningsAggregateByCab?.dayCab?.totalEarnings">
      <lohi-pie-chart
        [earnings]="metrics.earningsAggregateByCab?.dayCab?.averagePerDayEarnings"
        [lostEarnings]="metrics.earningsAggregateByCab?.dayCab?.missedAveragePerDayEarnings"
        [daysOfHistory]="metrics.daysOfHistory"
      >
      </lohi-pie-chart>
    </div>
  </div>
  <div class="col-span-3">
    <lohi-shift-averages></lohi-shift-averages>
  </div>
  <div class="col-span-3">
    <lohi-lost-earnings-by-driver-chart></lohi-lost-earnings-by-driver-chart>
  </div>
  <div class="col-span-3">
    <lohi-revenue-chart></lohi-revenue-chart>
  </div>
  <div class="col-span-3">
    <lohi-shifts-per-day-chart></lohi-shifts-per-day-chart>
  </div>
  <div class="col-span-3">
    <lohi-loads-per-day-chart></lohi-loads-per-day-chart>
  </div>
  <div>
    <div class="card-with-shadow mt-2 bg-white" *lohiFeatureFlag="'driverPerformance'">
      <div class="p-2 border-b border-gray-400">
        <div class="font-bold text-gray-700">Driver Performance <span class="text-blue-500">Past 24hrs</span></div>
        <div class="pt-2 pb-2 flex border-b border-gray-400">
          <div class="flex-1 text-gray-700">Late to Shift</div>
          <lohi-number-badge [count]="0"></lohi-number-badge>
        </div>
        <div class="pt-2 pb-2 flex border-b border-gray-400">
          <div class="flex-1 text-gray-700">Missing / Declined Loads</div>
          <lohi-number-badge [count]="5"></lohi-number-badge>
        </div>
        <div class="pt-2 pb-2 flex" *ngIf="642 as fakeMissingMinutes">
          <div class="flex-1 text-gray-700">Missed Minutes</div>
          <div class="flex ml-1 mr-1" *ngIf="fakeMissingMinutes > 0; else noMissingMinutes">
            <span style="width: 10px; height: 20px" class="rounded-tl-full rounded-bl-full bg-red-500"> </span>
            <span
              style="height: 20px"
              class="text-white text-sm flex justify-center leading-none items-center bg-red-500"
            >
              <span>{{ fakeMissingMinutes | prettyPrintMinutes }}</span></span
            >
            <span style="width: 10px; height: 20px" class="rounded-tr-full rounded-br-full bg-red-500"> </span>
          </div>
          <ng-template #noMissingMinutes>
            <div>
              {{ fakeMissingMinutes | prettyPrintMinutes }}
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="text-gray-600 text-center pb-2">All dates represent start of day in Central Time Zone</div>
